enum Languages {
  en,
  it,
  vi,
}

export default Languages;
